// Guaubuelo: adornos de temporada. Partículas ligeras en un canvas fijo, sin librerías.
// Se paran con la pestaña oculta y no salen con prefers-reduced-motion.
(() => {
  const html = document.documentElement;
  const clave = html.dataset.gbTemporada;

  // Vista previa forzada (?gb_temporada=): poner también el texto de la barra de esa temporada
  try {
    const textos = JSON.parse(document.getElementById('gb-temporada-textos')?.textContent || '{}');
    if (new URLSearchParams(location.search).get('gb_temporada')) {
      document.querySelectorAll('[data-gb-anuncio-temporada]').forEach((p) => {
        const partes = [clave && textos[clave], textos.envio].filter(Boolean);
        if (partes.length) p.textContent = partes.join(' · ');
      });
    }
  } catch (e) {}

  if (!clave || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // forma, colores, caída (px/s; negativo = sube), horizontal (vuelo de lado)
  const C = {
    navidad: ['huella', ['#b9c8d8', '#d6e0ea', '#ffffff'], 38],
    halloween: ['murcielago', ['#2a1535', '#3b1f4a'], 0, 55],
    reyes: ['estrella', ['#c9971c', '#f1d27a'], 28],
    sanvalentin: ['corazon', ['#e0607e', '#f6c2ce'], -26],
    primavera: ['petalo', ['#f2b5c8', '#f2d35c', '#ffffff'], 30],
    madre: ['flor', ['#b97aae', '#eac9e1'], 26],
    verano: ['burbuja', ['#2bb3b8', '#7fd3d6'], -30],
    otono: ['hoja', ['#d08a1e', '#ebc071', '#7a5210'], 34],
    otono2: ['hoja', ['#b5532f', '#e3a27c', '#6b3a22'], 34],
  }[clave];
  if (!C) return;
  const [forma, colores, caida, lado = 0] = C;

  const lienzo = document.createElement('canvas');
  lienzo.className = 'gbt-lienzo';
  // Dentro del hueco libre de cada pantalla: no pasa por encima de precios ni botones
  lienzo.style.zIndex = '0';
  lienzo.setAttribute('aria-hidden', 'true');
  document.body.append(lienzo);
  const ctx = lienzo.getContext('2d');
  let w, h, dpr;
  const medir = () => {
    dpr = Math.min(2, devicePixelRatio || 1);
    w = innerWidth;
    h = innerHeight;
    lienzo.width = w * dpr;
    lienzo.height = h * dpr;
    lienzo.style.width = w + 'px';
    lienzo.style.height = h + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  medir();
  addEventListener('resize', medir);

  const N = innerWidth < 750 ? 14 : 28;
  const azar = (a, b) => a + Math.random() * (b - a);
  const nueva = (inicio) => ({
    x: lado ? (inicio ? azar(0, w) : -30) : azar(0, w),
    y: lado ? azar(20, h * 0.6) : inicio ? azar(0, h) : caida < 0 ? h + 20 : -20,
    s: azar(6, 13),
    v: (caida || 0) * azar(0.6, 1.3),
    vx: lado * azar(0.6, 1.3),
    fase: azar(0, 6.3),
    giro: azar(-1, 1),
    c: colores[(Math.random() * colores.length) | 0],
  });
  const ps = Array.from({ length: N }, () => nueva(true));

  const dibujar = {
    huella(s) {
      ctx.beginPath(); ctx.arc(0, s * 0.3, s * 0.42, 0, 7); ctx.fill();
      for (const [x, y] of [[-0.45, -0.25], [-0.17, -0.5], [0.17, -0.5], [0.45, -0.25]]) { ctx.beginPath(); ctx.arc(x * s, y * s, s * 0.17, 0, 7); ctx.fill(); }
    },
    murcielago(s, t) {
      const a = Math.sin(t * 9) * 0.35 * s;
      ctx.beginPath(); ctx.moveTo(0, 0);
      ctx.quadraticCurveTo(-s * 0.6, -a - s * 0.3, -s, -a * 0.2);
      ctx.quadraticCurveTo(-s * 0.55, s * 0.05, -s * 0.2, s * 0.25);
      ctx.lineTo(0, s * 0.1); ctx.lineTo(s * 0.2, s * 0.25);
      ctx.quadraticCurveTo(s * 0.55, s * 0.05, s, -a * 0.2);
      ctx.quadraticCurveTo(s * 0.6, -a - s * 0.3, 0, 0); ctx.fill();
    },
    estrella(s) {
      ctx.beginPath();
      for (let i = 0; i < 10; i++) { const r = i % 2 ? s * 0.25 : s * 0.6, a = (i * Math.PI) / 5; ctx.lineTo(Math.sin(a) * r, -Math.cos(a) * r); }
      ctx.fill();
    },
    corazon(s) {
      ctx.beginPath(); ctx.moveTo(0, s * 0.45);
      ctx.bezierCurveTo(-s * 0.9, -s * 0.1, -s * 0.4, -s * 0.75, 0, -s * 0.25);
      ctx.bezierCurveTo(s * 0.4, -s * 0.75, s * 0.9, -s * 0.1, 0, s * 0.45); ctx.fill();
    },
    petalo(s) { ctx.beginPath(); ctx.ellipse(0, 0, s * 0.28, s * 0.55, 0, 0, 7); ctx.fill(); },
    flor(s) {
      for (let i = 0; i < 5; i++) { ctx.beginPath(); ctx.arc(Math.cos(i * 1.257) * s * 0.3, Math.sin(i * 1.257) * s * 0.3, s * 0.22, 0, 7); ctx.fill(); }
    },
    burbuja(s) { ctx.beginPath(); ctx.arc(0, 0, s * 0.4, 0, 7); ctx.lineWidth = 1.5; ctx.strokeStyle = ctx.fillStyle; ctx.stroke(); },
    hoja(s) {
      ctx.beginPath(); ctx.ellipse(0, 0, s * 0.3, s * 0.6, 0.3, 0, 7); ctx.fill();
      ctx.strokeStyle = 'rgba(0,0,0,.25)'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(-s * 0.15, s * 0.5); ctx.lineTo(s * 0.15, -s * 0.5); ctx.stroke();
    },
  }[forma];

  let anterior = performance.now();
  let activo = true;
  const paso = (ahora) => {
    if (!activo) return;
    const dt = Math.min(0.05, (ahora - anterior) / 1000);
    anterior = ahora;
    ctx.clearRect(0, 0, w, h);
    const t = ahora / 1000;
    for (let i = 0; i < ps.length; i++) {
      const p = ps[i];
      p.y += p.v * dt;
      p.x += lado ? p.vx * dt : Math.sin(t * 0.8 + p.fase) * 12 * dt;
      if (lado) p.y += Math.sin(t * 2 + p.fase) * 8 * dt;
      if (p.y > h + 30 || p.y < -30 || p.x > w + 40) ps[i] = nueva(false);
      ctx.save();
      ctx.translate(p.x, p.y);
      if (!lado) ctx.rotate(Math.sin(t * 0.6 + p.fase) * 0.6 * p.giro);
      ctx.fillStyle = p.c;
      dibujar(p.s, t + p.fase);
      ctx.restore();
    }
    requestAnimationFrame(paso);
  };
  requestAnimationFrame(paso);
  document.addEventListener('visibilitychange', () => {
    activo = !document.hidden;
    if (activo) { anterior = performance.now(); requestAnimationFrame(paso); }
  });
})();
